import { useCallback, useEffect, useState } from "react";

// Haversine distance in km
export function distanceKm(a, b) {
    if (!a || !b) return Infinity;
    const R = 6371;
    const toRad = (d) => (d * Math.PI) / 180;
    const dLat = toRad(b.lat - a.lat);
    const dLng = toRad(b.lng - a.lng);
    const s = Math.sin(dLat / 2) ** 2 +
              Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(s));
}

export default function useGeolocation({ watch = false } = {}) {
    const [pos, setPos] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const request = useCallback(() => {
        if (!("geolocation" in navigator)) {
            setError("Geolocation not supported by this browser");
            return;
        }
        setLoading(true);
        navigator.geolocation.getCurrentPosition(
            (p) => { setPos({ lat: p.coords.latitude, lng: p.coords.longitude }); setLoading(false); setError(null); },
            (err) => { setError(err.message || "Location denied"); setLoading(false); },
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 },
        );
    }, []);

    useEffect(() => {
        if (!watch) return;
        if (!("geolocation" in navigator)) return;
        const id = navigator.geolocation.watchPosition(
            (p) => setPos({ lat: p.coords.latitude, lng: p.coords.longitude }),
            (err) => setError(err.message || "Location denied"),
            { enableHighAccuracy: true, maximumAge: 30000 },
        );
        return () => navigator.geolocation.clearWatch(id);
    }, [watch]);

    return { pos, error, loading, request };
}
